import React from 'react';
import { logo } from '../utils/icons';

export const Logo = () => {
  return <h1 className="fs-16 logo">{logo}</h1>;
};
